import http from '../../core/services/http'

export const generateScrapingIssueReport = ({ startDate, endDate }) =>
  http.get(
    `/reports/scraping-issue?startDate=${startDate}&endDate=${endDate}`,
    { responseType: 'blob' },
  )
